import axiosInstance from "plugin/axios";

import { CalibrationReadParams, CalibrationDeleteParams, CalibrationCreateParams } from "interface/admin/interface.calibration";

export const fetchLoadAdminCalibration = async (params: CalibrationReadParams) => {
  try {
    const response = await axiosInstance.get(`/measurement/calibration`, { params });
    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const fetchDeleteAdminCalibration = async (params: CalibrationDeleteParams) => {
  try {
    const response = await axiosInstance.delete(`/measurement/calibration/${params.id}`);
    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const fetchCreateAdminCalibration = async (params: CalibrationCreateParams) => {
  try {
    const formData = new FormData();

    formData.append(
      "dto",
      JSON.stringify({
        serial: params.serial,
        memo: params.memo,
      })
    );

    if (params.files.length === 0) {
      throw new Error("파일은 최소 1개 이상이어야 합니다.");
    }

    params.files.forEach((file) => {
      formData.append("files", file);
    });

    const response = await axiosInstance.post("/measurement/calibration", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    throw new Error();
  }
}
